/* Read the existing complete review cohort. No persistence, requests, or invented proof. */
if (!customElements.get('worth-it-pdp-compass')) {
  customElements.define('worth-it-pdp-compass', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      const initialise = () => {
        if (this._initialised || !this.isConnected || this._controller.signal.aborted) return;
        // A recycled element never carries another product's feedback forward.
        const proof = this.querySelector('[data-wi-compass-proof]');
        const photoLink = this.querySelector('[data-wi-compass-photo-link]');
        if (proof) proof.hidden = true;
        if (photoLink) photoLink.hidden = true;
        this.querySelector('[data-wi-compass-thumbnails]')?.replaceChildren();
        this.querySelector('[data-wi-compass-rating]').textContent = '';
        this.querySelector('[data-wi-compass-count]').textContent = '';
        this.querySelector('[data-wi-compass-photo-count]').textContent = '';
        const id = this.dataset.productId;
        if (!/^\d+$/.test(id || '')) return;
        const reviews = document.getElementById(`WorthItReviews-${id}`);
        if (!reviews) return;
        this._initialised = true;
        const overviewLink = this.querySelector('[data-wi-compass-overview]');
        const overview = document.getElementById(`WorthItOverview-${id}`);
        if (!overview) overviewLink?.remove();
        const cards = Array.from(reviews.querySelectorAll('[data-wi-review-grid] [data-wi-review]'));
        const ids = new Set();
        let stars = 0;
        const valid = cards.length > 0 && cards.every(card => {
          const original = String(card.dataset.rating || '').trim();
          const reviewId = String(card.dataset.reviewId || '').trim();
          if (card.closest('[data-wi-reviews]') !== reviews || !/^[1-5](?:\.0+)?$/.test(original) || !reviewId || ids.has(reviewId)) return false;
          ids.add(reviewId);
          stars += Number(original);
          return true;
        });
        if (valid && proof) {
          this.querySelector('[data-wi-compass-rating]').textContent = `${(stars / cards.length).toFixed(1)} / 5`;
          this.querySelector('[data-wi-compass-count]').textContent = `${cards.length} published feedback ${cards.length === 1 ? 'entry' : 'entries'}`;
          const gallery = document.getElementById(`WorthItReviewPhotos-${id}`);
          const photos = Array.from(gallery?.querySelectorAll('[data-wi-photo-open]') || []).filter(anchor => ids.has(anchor.dataset.wiPhotoReviewId) && anchor.closest('[data-wi-reviews]') === reviews && anchor.querySelector('img'));
          const uniquePhotos = Array.from(new Map(photos.map(anchor => [anchor.getAttribute('href'), anchor])).values());
          if (uniquePhotos.length && photoLink) {
            const thumbnails = this.querySelector('[data-wi-compass-thumbnails]');
            uniquePhotos.slice(0, 3).forEach(anchor => {
              const original = anchor.querySelector('img');
              const image = document.createElement('img');
              const fullOriginal = anchor.href;
              if (original.dataset.wiCompassSizes) image.sizes = original.dataset.wiCompassSizes;
              if (original.dataset.wiCompassSrcset) image.srcset = original.dataset.wiCompassSrcset;
              image.alt = '';
              image.width = Number(original.getAttribute('width')) || 38;
              image.height = Number(original.getAttribute('height')) || 42;
              image.loading = 'lazy';
              image.decoding = 'async';
              image.addEventListener('error', () => {
                if (image.hasAttribute('srcset')) {
                  image.removeAttribute('srcset');
                  image.removeAttribute('sizes');
                  image.src = fullOriginal;
                } else image.remove();
              }, options);
              image.src = fullOriginal;
              thumbnails.appendChild(image);
            });
            this.querySelector('[data-wi-compass-photo-count]').textContent = `${uniquePhotos.length} source-buyer ${uniquePhotos.length === 1 ? 'photo' : 'photos'}`;
            photoLink.hidden = false;
          }
          proof.hidden = false;
        }
        this.addEventListener('click', event => {
          const anchor = event.target.closest('a[href^="#"]');
          if (!anchor || !this.contains(anchor) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(anchor.getAttribute('href').slice(1));
          if (!target) return;
          event.preventDefault();
          if (anchor.hasAttribute('data-wi-compass-overview') || anchor.hasAttribute('data-wi-compass-questions')) {
            const details = target.querySelector('details');
            if (details) details.open = true;
          }
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          const focusTarget = target.querySelector('summary, h2, h3') || target;
          const alreadyFocusable = focusTarget.matches('a,button,input,select,textarea,summary,[tabindex]');
          if (!alreadyFocusable) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
          if (!alreadyFocusable) focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
        }, options);
      };
      document.addEventListener('DOMContentLoaded', initialise, { ...options, once: true });
      initialise();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._initialised = false;
    }
  });
}
